import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

const variants = {
  default: 'bg-[rgba(64,219,241,0.12)] text-[#40dbf1] border-[rgba(64,219,241,0.25)]',
  success: 'bg-[rgba(74,222,128,0.12)] text-[#86efac] border-[rgba(74,222,128,0.25)]',
  warning: 'bg-[rgba(251,191,36,0.12)] text-[#fcd34d] border-[rgba(251,191,36,0.25)]',
  danger: 'bg-[rgba(248,113,113,0.12)] text-[#fca5a5] border-[rgba(248,113,113,0.25)]',
  muted: 'bg-[rgba(255,255,255,0.06)] text-[#9aabbb] border-[rgba(255,255,255,0.08)]',
}

export function Badge({
  children,
  variant = 'default',
  className,
}: {
  children: ReactNode
  variant?: keyof typeof variants
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
